import { axiosApiInstance, headers, multipart_headers } from './_httpHeaders';

export const getManuList = reqParam => axiosApiInstance({
    method: 'get',
    headers,
    url: `${process.env.REACT_APP_API_URL}/user/manuContract/selectManuContractList.do`,
    params: {
        apprYn: reqParam.apprYn,
        usCode: reqParam.usCode,
        startDt: reqParam.startDt, // 시작일자
        endDt: reqParam.endDt, // 종료일자
        searchText: reqParam.searchText, // 검색어
        page: reqParam.page, // 페이지
        perPageNum: reqParam.perPageNum, // 페이지당 표시 할 데이터 개수
        dataList: reqParam.dataList,
        checkDateType: reqParam.checkDateType
    }
})

export const getMemberList = () => axiosApiInstance({
    method: 'get',
    headers,
    url: `${process.env.REACT_APP_API_URL}/user/manuContract/selectMemberList.do`,
    params: {},
})

export const getCenterList = () => axiosApiInstance({
    method: 'get',
    headers,
    url: `${process.env.REACT_APP_API_URL}/user/manuContract/selectCenterList.do`,
    params: {},
})

export const ArchivefileDownload = (agcySeq) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    responseType: 'arraybuffer',
    url: `${process.env.REACT_APP_API_URL}/user/manuContract/ArchivefileDownload.do`,
    params: {
        agcySeq: agcySeq,
    },
})


export const getManuCodeList = reqParam => axiosApiInstance({
    method: 'get',
    headers,
    url: `${process.env.REACT_APP_API_URL}/user/manuContract/selectManuCodeList.do`,
    params: {
    }
})

export const insertManuList = reqParam => axiosApiInstance({
    method: 'post',
    headers,
    url: `${process.env.REACT_APP_API_URL}/user/manuContract/insertManuList.do`,
    params: {
    }
})

export const changeManuList = reqParam => axiosApiInstance({
    method: 'put',
    headers,
    url: `${process.env.REACT_APP_API_URL}/user/manuContract/changeManuList.do`,
    params: {
    }
})

export const deleteManuList = (formData) => axiosApiInstance({
    method: 'post',
    headers: multipart_headers,
    url: `${process.env.REACT_APP_API_URL}/user/manuContract/deleteManuList.do`,
    data: formData,
})

export const detailManuList = (agcySeq) => axiosApiInstance({
    method: 'get',
    headers,
    url: `${process.env.REACT_APP_API_URL}/user/manuContract/selectDetailManuList.do`,
    params: {
        agcySeq: agcySeq,
    }
})

export const uploadManuList = (formData) => axiosApiInstance({
    method: 'post',
    headers: multipart_headers,
    url: `${process.env.REACT_APP_API_URL}/user/manuContract/uploadManuList.do`,
    data: formData,
})

export const confirmManuList = (formData) => axiosApiInstance({
    method: 'post',
    headers: multipart_headers,
    url: `${process.env.REACT_APP_API_URL}/user/manuContract/confirmManuList.do`,
    data: formData,
})

export const rejectManuList = (formData) => axiosApiInstance({
    method: 'post',
    headers: multipart_headers,
    url: `${process.env.REACT_APP_API_URL}/user/manuContract/rejectManuList.do`,
    data: formData,
})

export const downloadManuList = reqParam => axiosApiInstance({
    method: 'get',
    headers,
    url: `${process.env.REACT_APP_API_URL}/user/manuContract/downloadManuList.do`,
    params: {
    }
})

export const updateManuList = (formData) => axiosApiInstance({
    method: 'post',
    headers: multipart_headers,
    url: `${process.env.REACT_APP_API_URL}/user/manuContract/updateManuList.do`,
    data: formData,
})

export const excelManuListDownload = reqParam => axiosApiInstance({
    method: 'get',
    headers,
    url: `${process.env.REACT_APP_API_URL}/user/manuContract/selectManuContractList.do`,
    params: {
        cpSxn: reqParam.cpSxn, // CP구분
        startDt: reqParam.startDt, // 시작일자
        endDt: reqParam.endDt, // 종료일자
        searchText: reqParam.searchText, // 검색어
        page: reqParam.page, // 페이지
        perPageNum: reqParam.perPageNum // 페이지당 표시 할 데이터 개수
    }
})
